import { render, staticRenderFns } from "./Haus.vue?vue&type=template&id=2bb7146c&"
import script from "./Haus.vue?vue&type=script&lang=js&"
export * from "./Haus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports